// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchFormsheetSuccess} from 'redux/v1/formsheet/actions';
import type {FormsheetState} from 'redux/v1/formsheet/FormsheetState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {FETCH_FORMSHEET} from 'redux/v1/formsheet/actions';
import {formsheetState} from 'redux/v1/V1State';

export const initialState: FormsheetState = {
  loading: false,
};

const actionCreators: ActionHandlers<FormsheetState> = {
  [PENDING(FETCH_FORMSHEET)]: (state: FormsheetState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_FORMSHEET)]: (
    state: FormsheetState,
    action: FetchFormsheetSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data,
  }),
  [ERROR(FETCH_FORMSHEET)]: (state: FormsheetState, action: any) => ({
    ...state,
    loading: false,
    error: action.error.toJSON(),
  }),
};

export const formsheetReducer: Reducer<FormsheetState> = // $FlowIgnore
  createReducerUsingActionHandlers<FormsheetState>(
    initialState,
    actionCreators
  );

export const getFormsheet: Selector<FormsheetState> = createSelector(
  formsheetState,
  (state: FormsheetState) => !state.loading && state.data
);
